import { ChangeDetectionStrategy, Component, HostBinding, input } from "@angular/core";

@Component({
	selector: "stages-sidesheet",
	template: "<ng-content />",
	styleUrls: ["./sidesheet.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidesheetComponent {
	readonly isSidesheetOpen = input<boolean>(false);
	readonly bannerEnabled = input<boolean>(false);

	@HostBinding("class.has-banner")
	get hasBanner(): boolean {
		return this.bannerEnabled();
	}

	@HostBinding("class.open")
	get isOpen(): boolean {
		return this.isSidesheetOpen();
	}
}
